import React, { FC } from 'react';
import { camelToSnake } from '../../../../caseUtils';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import {
  OpenCommentaryCard,
  PaperCommentaryCard,
  HybridCommentaryCard,
} from '../../../../commentary/card';
import { CommentaryTypeLabel } from '../../../../commentary/commentary.types';
import { EntityCommentary } from '../../../search.types';
import { GetCommentaryResponse } from '../commentaries-modal/decisionApi';
import { HitCommentariesListSeeMore } from './HitCommentariesListSeeMore';
import { ExcerptRelated } from '../../../../components/excerpt/related/ExcerptRelated';
import styles from './hit_commentaries_list.module.scss';

type Props = {
  commentaries: Array<EntityCommentary>;
  docId: string;
  numberOfComments: number;
  nextCommentAuthors: string[];
  otherCommentAuthorsCount: number;
  source: string;
  searchType: string;
  allCommentariesGetter: (
    docId: string,
    query: string,
  ) => Promise<{ data: Array<GetCommentaryResponse> }>;
};

export const HitCommentariesList: FC<Props> = ({
  commentaries,
  numberOfComments,
  otherCommentAuthorsCount,
  nextCommentAuthors = [],
  source,
  docId,
  allCommentariesGetter,
  searchType,
}) => {
  const onCommentaryClicked = (commentary: EntityCommentary) => () => {
    doctrineAnalytics('Search AbstractCommentClicked', {
      ...camelToSnake(commentary),
      reportOriginalQueryKey: true,
      search_type: searchType,
    });
  };

  const extraCommentaries = numberOfComments - commentaries.length;
  const hasMore = extraCommentaries > 0;
  const hasCommentaries = numberOfComments > 0;

  if (!hasCommentaries) {
    return null;
  }

  return (
    <ExcerptRelated>
      <div>
        {commentaries.map(commentary => {
          if (commentary.typeLabel === CommentaryTypeLabel.HYBRID) {
            return (
              <HybridCommentaryCard
                className={styles.item}
                commentary={commentary}
                key={commentary.commentaryId}
                source={source}
                onCommentaryClicked={onCommentaryClicked(commentary)}
                small
              />
            );
          }
          if (commentary.typeLabel === CommentaryTypeLabel.PAPER) {
            return (
              <PaperCommentaryCard
                className={styles.item}
                key={commentary.commentaryId}
                commentary={commentary}
                small
              />
            );
          }
          return (
            <OpenCommentaryCard
              className={styles.item}
              key={commentary.commentaryId}
              commentary={commentary}
              source={source}
              onCommentaryClicked={onCommentaryClicked(commentary)}
              small
            />
          );
        })}
      </div>
      {hasMore && (
        <HitCommentariesListSeeMore
          docId={docId}
          allCommentariesGetter={allCommentariesGetter}
          searchType={searchType}
          numberOfComments={numberOfComments}
          commentaries={commentaries}
          nextCommentAuthors={nextCommentAuthors}
          otherCommentAuthorsCount={otherCommentAuthorsCount}
        />
      )}
    </ExcerptRelated>
  );
};
